import React from "react";
import "./style.scss";
import laptopBg from "../../../assets/images/laptop_bg_img.png";

const AuthFrame = () => {
  return (
    <div className="authframe-container">
      <div className="authframe_bg">
        <span></span>
      </div>
      <img src={laptopBg} alt="laptop_bg" className="laptop_bg_img" />
    </div>
  );
};

export default AuthFrame;
